import { NavLink, Outlet } from 'react-router-dom';
import { UiIcon } from '../components/ui-icon';
import { useI18n } from '../i18n/i18n-provider';

export function PlatformLayout() {
  const { t } = useI18n();

  return (
    <section className="workspace-frame surface surface--platform" data-surface="platform">
      <aside className="workspace-frame__rail">
        <div className="workspace-frame__intro">
          <span className="workspace-frame__intro-mark">
            <UiIcon name="platform" className="feature-card__icon-svg" />
          </span>
          <span className="page__eyebrow">{t('nav.platform')}</span>
          <strong className="workspace-frame__title">{t('platform.title')}</strong>
          <p className="text-muted">{t('platform.intro')}</p>
        </div>
        <nav className="surface__nav workspace-frame__nav" aria-label={t('nav.platform')}>
          <NavLink to="/platform" end className="surface__nav-link">
            <span className="surface__nav-link-label">
              <span className="surface__nav-link-icon">
                <UiIcon name="tenant" className="feature-card__icon-svg" />
              </span>
              {t('nav.tenants')}
            </span>
          </NavLink>
        </nav>
      </aside>
      <div className="workspace-frame__content">
        <Outlet />
      </div>
    </section>
  );
}
